import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BusDetailsComponent } from '../shared/components/bus-details/bus-details.component';
import { Overlay } from '@angular/cdk/overlay';
import { BusDetailsMoreComponent } from '../shared/modals/bus-details-more/bus-details-more.component';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  modalRefBusDetails!: MatDialogRef<any>;
  modalRefBusMoreDetails!: MatDialogRef<any>;

  constructor(private dialog: MatDialog, private overlay: Overlay) {}

  showBusDetails(details): void {
    this.hideBusDetails();
    this.hideBusMoreDetails();
    this.modalRefBusDetails = this.dialog.open(BusDetailsComponent, {
      width: '330px',
      maxWidth: '90vw',
      maxHeight: '90vh',
      disableClose: false,
      hasBackdrop: false,
      autoFocus: false,
      data: { details },
      panelClass: 'bus-details-dialog',

    });
  }

  hideBusDetails(): void {
    if (this.modalRefBusDetails) {
      this.modalRefBusDetails.close();
    }
  }

  showBusMoreDetails(details): void {
    this.hideBusDetails()
    this.modalRefBusMoreDetails = this.dialog.open(BusDetailsMoreComponent, {
      width: '450px',
      maxWidth: '90vw',
      maxHeight: '90vh',
      disableClose: false,
      hasBackdrop: false,
      autoFocus: false,
      data: { details },
      panelClass: 'bus-more-details-dialog',

    });
  }

  hideBusMoreDetails(): void {
    if (this.modalRefBusMoreDetails) {
      this.modalRefBusMoreDetails.close();
    }
  }
}
